import { render, staticRenderFns } from "./CheckoutReceipts.vue?vue&type=template&id=0b81f4d0&"
import script from "./CheckoutReceipts.vue?vue&type=script&lang=js&"
export * from "./CheckoutReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports